<template lang="html">
    <form class="form3" @submit.prevent="saveSettings" v-if="editOpen">
        <div class="group">
            <div class="formGroup third">
                <vue-timepicker v-model="form.start" :minute-interval="15"></vue-timepicker>
            </div>
            <div class="formGroup third">
                <vue-timepicker v-model="form.end" :minute-interval="15"></vue-timepicker>
            </div>
            <div class="formGroup third">
                <button @click.prevent="updateTime" class="button" type="button" name="button">
                    Confirm
                </button>
            </div>
        </div>

        <has-error class="info error" :form="form" field="times"></has-error>
    </form>
    <div class="availabilityItem" v-else>
        {{ $date(time.date).format("D MMM YYYY") }} -
        {{ $date("2020-12-08 " + time.start).format("HH:mm") }} -
        {{ $date("2020-12-08 " + time.end).format("HH:mm") }}
        <button @click.prevent="menuOpen = true" class="menuIcon"><i /><i /><i /></button>
        <ul class="menu" v-if="menuOpen && !editOpen">
            <li><button @click.prevent="editOpen = true" class="edit">Edit</button></li>
            <li><button @click.prevent="deleteTime" class="delete">Delete</button></li>
        </ul>
    </div>
</template>

<script>
import { Form, HasError } from "vform";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
export default {
    name: "availability-item",
    props: {
        time: {
            type: Object,
            required: true,
        },
    },
    components: { VueTimepicker, HasError },
    computed: {
        start_date() {
            return this.$date(this.$route.params.start).format("D MMM YYYY");
        },
        end_date() {
            return this.$date(this.$route.params.end).format("D MMM YYYY");
        },
    },
    data() {
        return {
            menuOpen: false,
            editOpen: false,
            form: new Form({
                id: this.time.id,
                start: this.time.start,
                end: this.time.end,
                date: this.time.date,
                times: [{ start: this.time.start, end: this.time.end }],
                start_date: this.start_date,
                end_date: this.end_date,
            }),
        };
    },
    methods: {
        updateTime() {
            this.form.times = [{ start: this.form.start, end: this.form.end }];
            this.form.start_date = this.start_date;
            this.form.end_date = this.end_date;
            this.form.put("/availability/" + this.form.id).then((time) => {
                this.$emit("updateAvailability", time.data);
                this.editOpen = false;
                this.menuOpen = false;
                this.$notify({
                    text: "Your availability has been updated",
                });
            });
        },
        deleteTime() {
            this.$confirm("Are you sure you want to delete this time?", () => {
                this.form.delete("/availability/" + this.time.id).then(() => {
                    this.menuOpen = false;
                    this.menuOpen = false;
                    this.$emit("removeAvailability", this.time);
                    this.$notify("Availability removed");
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.availabilityItem {
    background: white;
    border-radius: $radius;
    padding: 20px;
    color: $green_0;
    position: relative;
    margin-bottom: 10px;
    .menu {
        position: absolute;
        right: 0px;
        top: 0px;
        height: 100%;
        li {
            display: inline-block;
            height: 100%;
            button {
                width: 80px;
                height: 100%;
                font-size: 1rem;
                color: white;
                &:focus {
                    outline: 0 !important;
                }
                &.edit {
                    background: $green_0;
                    border-top-right-radius: $radius;
                    border-bottom-right-radius: $radius;
                    margin-right: -10px;
                    z-index: 1;
                    position: relative;
                    &:before {
                        content: "";
                        width: 10px;
                        height: 100%;
                        background: white;
                        display: block;
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        border-top-right-radius: $radius;
                        border-bottom-right-radius: $radius;
                    }
                }
                &.delete {
                    background: $red;
                    border-top-right-radius: $radius;
                    border-bottom-right-radius: $radius;
                }
            }
        }
    }
    button {
        background: none;
        border: 0px;
    }
    .menuIcon {
        float: right;

        width: 53px;
        height: 50px;
        position: absolute;
        top: 0px;
        right: 10px;
        i {
            width: 5px;
            height: 5px;
            display: inline-block;
            background: $green_0;
            border-radius: 100%;
            margin-left: 5px;
        }
    }
}

.group {
    display: flex;
    .formGroup {
        margin-right: 10px;
        margin-bottom: 10px;
        flex: 1;
        &:last-of-type {
            margin-right: 0px;
        }
    }
}
</style>
